export const QUICK_MESSAGES_MANAGEMENT_TYPES = new Map([
  ['patient', 1],
  ['caregiver', 2]
])
